// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Nh9O","item":"PaymentsMobile_item__2s3-N","label":"PaymentsMobile_label__wFh5R","amount":"PaymentsMobile_amount__MjFsI"};